/**
 * Designed  & Developed by Faisal Nadaf
 * Contact: faisalfnadaf@gmail.com
 *
 * @format
 */

import { Navigation } from "@/components/customCopmonent/landingSection/navigation";
import { FooterSection } from "@/components/customCopmonent/landingSection/footer-section";
import CircularGallery from "@/components/customCopmonent/CircularGallery";
import DotGrid from "@/components/customCopmonent/DotGrid";
import { PageHeaderHero, PAGE_HERO_CLASS } from "@/components/customCopmonent/Text/PageHeaderHero";
import { SectionWrapper } from "../Clientele.page-primitives";
import { PageHeader } from "@/components/customCopmonent/Text/PageHeader";
import { RevealOnScroll } from "@/components/SpecialProjectsPage.primitives";

import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useTranslation } from "react-i18next";
import Seo from "@/components/Seo";
import { useIsMobile } from "@/hooks/hooks/use-mobile";
import {
	IndustrySectionProduct,
	IndustrySectionApplication,
} from "@/components/customCopmonent/IndustryCardsAP";

// Register ScrollTrigger
if (typeof window !== "undefined") {
	gsap.registerPlugin(ScrollTrigger);
}

const WaterTreatment = () => {
	const { t } = useTranslation();
	const isMobile = useIsMobile();

	// const pageData = {
	// 	title: "Power Generation & Distribution",
	// 	bgimage: "/images/headerPhotos/DSC09146.JPG",

	// 	description:
	// 		"Engineered thermal solutions supporting the full power lifecycleâ€”from generation to transmission and distribution. .",

	// 	meta: [
	// 		"High Efficiency Systems",
	// 		"Grid Reliability",
	// 		"Critical Infrastructure",
	// 	],

	// 	subIndustries: {
	// 		title: "Operational Segments",
	// 		description:
	// 			"Comprehensive thermal engineering solutions tailored for diverse power generation and distribution segments, ensuring efficiency, safety, and long-term operational reliability.",

	// 		industries: [
	// 			{
	// 				image:
	// 					"/images/industriesPhotos/WaterTreatment/SubIndustries/Municipal-Water-and-wastewater-treatment.webp",
	// 				text: "Municipal Water Treatment Plants",
	// 			},
	// 			{
	// 				image:
	// 					"/images/industriesPhotos/WaterTreatment/SubIndustries/sewage-treatement-plants.jpg",
	// 				text: "Sewage Treatment Plants (STP)",
	// 			},
	// 			{
	// 				image:
	// 					"/images/industriesPhotos/WaterTreatment/SubIndustries/Effluent-Treatment-Plant.jpg",
	// 				text: "Effluent Treatment Plants (ETP)",
	// 			},
	// 			{
	// 				image:
	// 					"/images/industriesPhotos/WaterTreatment/SubIndustries/Desalination Plants.webp",
	// 				text: "Desalination Plants",
	// 			},
	// 			{
	// 				image:
	// 					"/images/industriesPhotos/WaterTreatment/SubIndustries/industrial-water-treatment-system.jpg",
	// 				text: "Industrial Water Treatment Systems",
	// 			},
	// 		],
	// 	},

	// 	applications: {
	// 		title: "Applications",
	// 		description:
	// 			"Critical cooling and heat transfer applications designed to optimize performance, enhance equipment lifespan, and maintain operational stability in demanding power environments.",

	// 		applications: [
	// 			{
	// 				image:
	// 					"/images/industriesPhotos/WaterTreatment/Application/Turbine Cooling.webp",
	// 				title: "Turbine Cooling",
	// 				description:
	// 					"Efficient thermal regulation systems ensuring optimal turbine performance under continuous high-load operations.",
	// 			},
	// 			{
	// 				image:
	// 					"/images/industriesPhotos/WaterTreatment/Application/Generator Cooling.webp",
	// 				title: "Generator Cooling",
	// 				description:
	// 					"Advanced cooling solutions to maintain generator efficiency and prevent overheating in large-scale power systems.",
	// 			},
	// 			{
	// 				image:
	// 					"/images/industriesPhotos/WaterTreatment/Application/Transformer Oil Cooling.webp",
	// 				title: "Transformer Oil Cooling",
	// 				description:
	// 					"Reliable cooling systems designed to regulate transformer oil temperatures and ensure grid stability.",
	// 			},
	// 			{
	// 				image:
	// 					"/images/industriesPhotos/WaterTreatment/Application/Substation Cooling.webp",
	// 				title: "Substation Cooling",
	// 				description:
	// 					"Thermal management solutions for substations to maintain consistent performance in fluctuating load conditions.",
	// 			},
	// 			{
	// 				image:
	// 					"/images/industriesPhotos/WaterTreatment/Application/Condensation Systems.webp",
	// 				title: "Condensation Systems",
	// 				description:
	// 					"High-efficiency condensation units for steam cycle optimization and energy recovery.",
	// 			},
	// 			{
	// 				image:
	// 					"/images/industriesPhotos/WaterTreatment/Application/Boiler Feedwater Systems.webp",
	// 				title: "Boiler Feedwater Systems",
	// 				description:
	// 					"Precision heating and cooling systems ensuring optimal boiler feedwater temperature control.",
	// 			},
	// 			{
	// 				image:
	// 					"/images/industriesPhotos/WaterTreatment/Application/Heat Recovery Systems.webp",
	// 				title: "Heat Recovery Systems",
	// 				description:
	// 					"Energy-efficient systems capturing and reusing waste heat to improve overall plant efficiency.",
	// 			},
	// 			{
	// 				image:
	// 					"/images/industriesPhotos/WaterTreatment/Application/Primary Air (PA) Systems.webp",
	// 				title: "Primary Air (PA) Systems",
	// 				description:
	// 					"Thermal solutions supporting efficient air flow and combustion processes in boilers.",
	// 			},
	// 			{
	// 				image:
	// 					"/images/industriesPhotos/WaterTreatment/Application/FD & ID Fan Oil Cooling.webp",
	// 				title: "FD & ID Fan Oil Cooling",
	// 				description:
	// 					"Cooling systems designed to maintain optimal lubrication and performance of forced and induced draft fans.",
	// 			},
	// 			{
	// 				image:
	// 					"/images/industriesPhotos/WaterTreatment/Application/Mechanical Seal Cooling.webp",
	// 				title: "Mechanical Seal Cooling",
	// 				description:
	// 					"Reliable cooling solutions ensuring longevity and leak-proof performance of mechanical seals.",
	// 			},
	// 			{
	// 				image:
	// 					"/images/industriesPhotos/WaterTreatment/Application/Pulverizer Systems.webp",
	// 				title: "Pulverizer Systems",
	// 				description:
	// 					"Thermal management solutions supporting efficient coal pulverization and combustion processes.",
	// 			},
	// 		],
	// 	},

	// 	products: {
	// 		title: "Products",
	// 		description:
	// 			"Robust and high-performance heat exchange equipment engineered to meet the demanding requirements of modern power generation and distribution systems.",
	// 		products: [
	// 			{
	// 				image: "/images/worldwide/IOCL.jpg",
	// 				title: "Air Cooled Heat Exchangers",
	// 				href: "/products/air-cooled-heat-exchangers?industry=water-treatment",
	// 				description:
	// 					"Efficient cooling solutions ideal for water-scarce environments and high-temperature applications.",
	// 			},
	// 			{
	// 				image: "/images/worldwide/Banglore.jpeg",
	// 				title: "Double Pipe Heat Exchangers",
	// 				href: "/products/air-cooled-heat-exchangers?industry=water-treatment",

	// 				description:
	// 					"Compact and reliable units for precise heat transfer in low to medium capacity systems.",
	// 			},
	// 			{
	// 				image: "/images/worldwide/Doosa.jpeg",
	// 				title: "Shell & Tube Heat Exchangers",
	// 				href: "/products/air-cooled-heat-exchangers?industry=water-treatment",

	// 				description:
	// 					"Industry-standard heat exchangers designed for high-pressure and high-temperature operations.",
	// 			},
	// 			{
	// 				image: "/images/worldwide/Ancho.jpeg",
	// 				title: "Water Cooled Air Coolers",
	// 				href: "/products/air-cooled-heat-exchangers?industry=water-treatment",

	// 				description:
	// 					"Hybrid cooling systems combining air and water for enhanced thermal efficiency.",
	// 			},
	// 			{
	// 				image: "/images/worldwide/ADNOC-HAI.jpeg",
	// 				title: "Recuperators",
	// 				href: "/products/air-cooled-heat-exchangers?industry=water-treatment",

	// 				description:
	// 					"Energy recovery systems that improve efficiency by reusing waste heat in industrial processes.",
	// 			},
	// 		],
	// 	},
	// };

	const subIndustryImages = [
		"/images/industriesPhotos/WaterTreatment/SubIndustries/download.jpg",
		"/images/industriesPhotos/WaterTreatment/SubIndustries/Sewage Treatment Plants.jpg",
		"/images/industriesPhotos/WaterTreatment/SubIndustries/Effluent Treatment Plants.jpg",
		"/images/industriesPhotos/WaterTreatment/SubIndustries/Desalination Plants.jpg",
		"/images/industriesPhotos/WaterTreatment/SubIndustries/Industrial Water Treatment Systems.jpg",
	];

	const applicationImages = [
		"/images/industriesPhotos/WaterTreatment/Application/Sludge Digester Heating & Cooling.jpg",
		"/images/industriesPhotos/WaterTreatment/Application/Aeration Blower Aftercooling.jpg",
		"/images/industriesPhotos/WaterTreatment/Application/Effluent Cooling.jpg",
		"/images/industriesPhotos/WaterTreatment/Application/Desalination Thermal Processes.jpg",
		"/images/industriesPhotos/WaterTreatment/Application/Process Water Temperature Control.jpg",
		"/images/industriesPhotos/WaterTreatment/Application/Heat Recovery from Treatment Processes.jpg",
	];

	const subIndustryTexts = t(
		"industryPages.waterTreatment.subIndustries.items",
		{ returnObjects: true },
	) as string[];
	const applicationItems = t(
		"industryPages.waterTreatment.applications.items",
		{ returnObjects: true },
	) as { title: string; description: string }[];

	const pageData = {
		title: t("industryPages.waterTreatment.title"),
		bgimage: "/images/header/water.jpg",

		description: t("industryPages.waterTreatment.tagline"),

		meta: t("industryPages.waterTreatment.meta", {
			returnObjects: true,
		}) as string[],

		subIndustries: {
			title: t("industryPages.waterTreatment.subIndustries.title"),

			industries: subIndustryImages.map((image, i) => ({
				image,
				text: subIndustryTexts[i],
			})),
		},

		applications: {
			title: t("industryPages.waterTreatment.applications.title"),

			applications: applicationImages.map((image, i) => ({
				image,
				title: applicationItems[i].title,
				description: applicationItems[i].description,
			})),
		},
	};
	return (
		<>
			<Seo
				titleKey="industryPages.waterTreatment.seo.title"
				descriptionKey="industryPages.waterTreatment.seo.description"
				path="/industries/water-treatment"
			/>
			<Navigation />
			<SectionWrapper className={PAGE_HERO_CLASS}>
				<div className="absolute inset-0 ">
					{" "}
					<div
						className="absolute bottom-3 inset-0 opacity-35 scale-105"
						style={{
							backgroundImage: `url(${pageData.bgimage})`,
							backgroundSize: "cover",
							backgroundPosition: "center",
						}}
					/>
					<DotGrid
						dotSize={4}
						gap={15}
						baseColor="#3b0092"
						activeColor="#f09a38"
						proximity={100}
						shockRadius={200}
						shockStrength={3}
						resistance={750}
						returnDuration={1.5}
					/>
				</div>
				<PageHeaderHero
					// align="center"
					title={pageData.title}
					description={pageData.description}
					meta={pageData.meta}
				/>{" "}
			</SectionWrapper>

			<SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				{" "}
				<div className="relative flex flex-col items-center justify-center ">
					{/* ===== HEADER ===== */}
					<RevealOnScroll>
						<PageHeader
							title={pageData.subIndustries.title}
							align="center"
							className="py-6 text-center items-center "
						/>
					</RevealOnScroll>
				</div>
				<div className="relative h-[360px] sm:h-[460px] lg:h-[600px]">
					<CircularGallery
						items={pageData.subIndustries.industries}
						textColor="#000"
						borderRadius={0.05}
						bend={isMobile ? 0 : -3}
						scrollSpeed={1.5}
						scrollEase={0.05}
					/>
				</div>
			</SectionWrapper>
			<SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				<IndustrySectionApplication
					applications={pageData.applications.applications}
					title={pageData.applications.title}
				/>{" "}
			</SectionWrapper>
			{/* <SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				<IndustrySectionProduct
					applications={pageData.products.products}
					title={pageData.products.title}
					description={pageData.products.description}
				/>{" "}
			</SectionWrapper> */}
			<FooterSection />
		</>
	);
};

export default WaterTreatment;
